import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { Language } from '../../interfaces/language';
import { LanguageStore, LanguageState } from './language.store';

@Injectable({ providedIn: 'root' })
export class LanguageQuery extends QueryEntity<LanguageState, Language> {
	constructor(protected store: LanguageStore) {
		super(store);
	}
}
